import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';

const styles = {
  locationContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  buttonContainer: {
    width: '100%',
    padding: 0,
    mb: '6px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    p: '16px',
  },
  totalShifts: { fontSize: '16px', fontWeight: 600 },

  sortDropdown: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiInputLabel-root': {
      marginBottom: 0,
      mr: 1,
      fontSize: 13,
    },
    '& .MuiInputBase-root': {
      border: '1px solid',
      color: 'primary.main',
      fontSize: 12,
      flex: '0 0 200px',
      minWidth: 200,
      maxWidth: 200,
      width: 200,
    },
    '& fieldset': { border: 'none' },
  },
  locationIcon: {
    marginRight: '5px',
  },
  menu: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
  },
  footerContainer: {
    backgroundColor: 'secondary.main',
    p: '12px 24px 24px 24px',
    borderTop: '1px solid',
    borderColor: 'common.border',
  },
  zeroMargin: {
    my: 0,
    minWidth: 245,
  },
  shiftLabel: { mb: '12px' },
  iconColor: {
    color: 'red',
  },
  rightContainer: {
    display: 'flex',
    flex: 1,
    mb: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
